<template>
    <footer>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="footer-top">
                            <p>
                                <span>Order online with confidence using our secure payment system.</span><br />
                                <span v-if="internationalTelNo">Alternatively you can call us on {{internationalTelNo}} to place your order.</span>
                            </p>
                            <img :src="s3+'/images/payment-methods_new.png'" class="img-fluid"  alt="My Healthy Staff payment methods"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="footer-bottom">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <ul class="list-unstyled">
                            <li>
                                <router-link to="/" @click.native="scrollToTop">Home</router-link>
                            </li>
                            <li>
                                <router-link to="/help" @click.native="scrollToTop">Help</router-link>
                            </li>
                            <li>
                                <router-link to="/contact" @click.native="scrollToTop">Contact Us</router-link>
                            </li>
                            <li>
                                <router-link to="/help/terms-conditions" @click.native="scrollToTop">Terms & Conditions</router-link>
                            </li>
                            <li>
                                <router-link to="/help/accessibility-statement" @click.native="scrollToTop">Accessibility</router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="w-100"></div>

                    <div class="col">
                        <p>The Health & Safety Group Ltd, Building 5, 3rd Floor, 566 Chiswick High Road, Chiswick, London W4 5YF, Company Reg No 5250327</p>
                    </div>
                </div>
            </div>
        </section>
    </footer>
</template>

<script>
import GenericMixin from "@/mixins/GenericMixin";
    export default {
        name: "app-footer",
                data() {
            return {
                s3: process.env.VUE_APP_CDN_IMAGE_URL
            };
        },
        mixins: [GenericMixin],
        methods: {
            scrollToTop() {
                document.getElementById("headerSection").scrollIntoView();
                //window.scrollTo(0, 0);
            }
        }
    };
</script>

<style lang="scss" scoped>
    footer {
        margin-top: 12px;
        .footer-top {
            border-top: thin solid #828282;
            padding-top: 15px;
        }
        .footer-bottom {
            background: #4d4d4d;
            padding: 30px 0;
            color: white;
            li a {
                color: white !important;
            }
            ul {
                display: flex;
                justify-content: space-evenly;
                border-bottom: thin solid #fff;
                padding-bottom: 25px;
                margin-bottom: 25px;
            }

            @media (max-width: 540px) {
                 ul {
                    display: block;
                }
            }
        }
    }


    footer .footer-top {
        img {
            width: auto;
        }
    }
    @media (max-width: 575px) {
        footer .footer-top {
            img {
                width: auto;
            }
        }
    }
</style>
